export default __webpack_public_path__ + "static/media/Parallax-HUD-00.7fbd1862.jpg";